import { render, staticRenderFns } from "./DifferentModes.vue?vue&type=template&id=b0c0fd8a&"
import script from "./DifferentModes.vue?vue&type=script&lang=js&"
export * from "./DifferentModes.vue?vue&type=script&lang=js&"
import style0 from "./DifferentModes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports